<template>
  <div class="modal-card">
    <b-loading :isFullPage="false" :active="isLoading" />
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">{{
        General.TEXTS.UNITY_PERMISSIONS
      }}</span>
      <div class="close-button cursor-pointer" @click.stop="close">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container">
      <section class="mx-35 mt-35">
        <article>
          <span class="has-text-color-8 has-text-weight-semibold">{{
            General.RECEIVER
          }}</span>
          <div class="is-flex is-justify-content-space-between mt-10">
            <b-checkbox
              v-model="permissions.external_receptor"
              :type="isContrast ? 'is-white' : 'is-blue-oil'"
              class="has-text-color-8"
              >{{ General.EXTERNAL }}</b-checkbox
            >
            <b-checkbox
              v-model="permissions.internal_receptor"
              :type="isContrast ? 'is-white' : 'is-blue-oil'"
              class="has-text-color-8"
              >{{ General.INTERNAL }}</b-checkbox
            >
          </div>
        </article>
        <hr class="my-10" />
        <article>
          <span class="has-text-color-8 has-text-weight-semibold">{{
            General.PROCESSING
          }}</span>
          <div class="is-flex is-justify-content-space-between mt-10">
            <b-checkbox
              v-model="permissions.external_tramit"
              :type="isContrast ? 'is-white' : 'is-blue-oil'"
              class="has-text-color-8"
              >{{ General.EXTERNAL }}</b-checkbox
            >
            <b-checkbox
              v-model="permissions.internal_tramit"
              :type="isContrast ? 'is-white' : 'is-blue-oil'"
              class="has-text-color-8"
              >{{ General.INTERNAL }}</b-checkbox
            >
          </div>
        </article>
      </section>

      <section class="mx-35 mt-40 capacities">
        <b-table :data="capacity" hoverable>
          <b-table-column v-slot="{ row }" :label="General.UNITY">
            <span class="is-size-7 has-text-weight-semibold has-text-color-8">
              {{ getAbbreviationById(row) }}
            </span>
          </b-table-column>
        </b-table>
      </section>

      <footer class="modal-card-foot is-align-self-flex-end">
        <div class="buttons">
          <b-button
            :type="isContrast ? 'is-white' : 'is-green-lawn'"
            @click="confirmAction"
          >
            {{ General.SAVE }}
          </b-button>
          <b-button
            :type="isContrast ? 'is-white' : 'is-orange'"
            class="is-outlined"
            @click="close"
          >
            {{ General.CANCEL }}
          </b-button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { General } from "@/utils/constants";
import { truncate } from "lodash";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ModalCapacityPermissionEdit",

  props: {
    capacity: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      General,
      isLoading: false,
      permissions: {}
    };
  },

  computed: {
    ...mapGetters({
      getCapacityById: "getCapacityById",
      isContrast: "isContrast"
    })
  },

  beforeMount() {
    if (this.capacity.length === 1) {
      const {
        internal_receptor,
        external_receptor,
        internal_tramit,
        external_tramit
      } = this.capacity[0];
      this.permissions = {
        internal_receptor,
        external_receptor,
        internal_tramit,
        external_tramit
      };
    } else
      this.permissions = {
        internal_receptor: false,
        external_receptor: false,
        internal_tramit: false,
        external_tramit: false
      };
  },

  methods: {
    ...mapActions({
      setPermission: "setCapacityPermissionRequest",
      capacityControlRequest: "capacityControlRequest"
    }),
    async confirmAction() {
      this.isLoading = true;
      await this.setPermission({
        capacityId: this.capacity.map(({ id }) => id),
        permissions: this.permissions,
        update: true
      });
      this.isLoading = false;
      this.close();
    },

    close() {
      this.$parent.close();
    },

    getAbbreviationById(capacity) {
      return `${truncate(capacity.description, { length: 80 })}${
        this.getCapacityById(capacity.id)?.abbreviation
          ? " - " + this.getCapacityById(capacity.id).abbreviation
          : ""
      }`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  max-height: 75vh;
  background-color: $color-1;
}

.header-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.card-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.modal-content-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
}

.capacities {
  max-height: 200px;
  overflow-y: auto;
}
</style>
